import { render } from "./CreateListsInfoPopup.vue?vue&type=template&id=8d1a4814&scoped=true"
import script from "./CreateListsInfoPopup.vue?vue&type=script&lang=js"
export * from "./CreateListsInfoPopup.vue?vue&type=script&lang=js"

import "./CreateListsInfoPopup.vue?vue&type=style&index=0&id=8d1a4814&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/components/elements/my-lists/create-lists-info-popup.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fmy-lists%2FCreateListsInfoPopup.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1a4814"]])

export default __exports__